import { Component, OnDestroy, OnInit } from '@angular/core';
import { SituViewWebApiClient, ListPagedArtifactsRequest, IArtifactVersionItem, ArtifactVersion, SetArtifactActiveRequest } from 'situview-webapi-client';
import { Subject, Subscription } from 'rxjs';
import { AuthService, BreadcrumbService, StateService } from 'src/app/services';
import { MatTableDataSource } from '@angular/material/table';
import { Role } from 'src/app/shared/models/role.model';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from 'identity-webapi-client';

@Component({
  selector: 'app-artifact-list',
  templateUrl: './artifact-list.component.html',
  styleUrls: ['./artifact-list.component.less'],
})
export class ArtifactListComponent implements OnInit, OnDestroy {
  selectedCompany: Company | undefined;
  id: string | undefined;

  pageIndex = 1;
  pageSize = 25;
  totalItems = 0;

  displayedColumns: string[] = ['refKey', 'version', 'dateAdded', 'toggle', 'id'];

  activeOnly: boolean = false;
  containsFilter: string = '';
  admin = false;

  dataSource = new MatTableDataSource<IArtifactVersionItem>();

  prevSearch: string = '';
  
  private _subscriptions: Subscription[] = [];

  private _loading = false;
  public get loading(): boolean {
    return this._loading;
  }

  public set loading(val: boolean) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private situViewClient: SituViewWebApiClient,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private stateService: StateService) {
    this.admin = (this.authService.hasRole(Role.SituSystemsDeveloper) || this.authService.hasRole(Role.SituSystemsAdmin));
    this.id = this.route.snapshot.queryParams['id'];
  }

  ngOnInit(): void {
    this._subscriptions.push(this.stateService.state$.subscribe((state) => {
      if (this.selectedCompany?.code !== state?.company?.code) {
        this.selectedCompany = state.company as Company ?? undefined;
        if (this.id) this.containsFilter = this.id;
        this.loadArtifacts();
      }
    }));
  }

  ngOnDestroy(): void {
    if (this._subscriptions) {
      this._subscriptions.forEach(subscription => {
        if (subscription) {
          subscription.unsubscribe();
        }
      })
    }
  };

  onPageChange(evt: PageEvent) {
    this.pageSize = evt.pageSize;
    this.pageIndex = evt.pageIndex;
    this.loadArtifacts();
  }

  loadArtifacts() {
    this.loading = true;

    var request = new ListPagedArtifactsRequest();
    request.builder = this.selectedCompany?.code;
    request.includeBuilders = this.admin;
    request.containsFilter = this.containsFilter?.trim();
    request.includeDisabled = !this.activeOnly;

    let requestJson = JSON.stringify(request);
    if (!this.prevSearch || this.prevSearch != requestJson) {
      this.pageIndex = 0;
    }

    this.prevSearch = JSON.stringify(request);
    request.pageNumber = this.pageIndex + 1;
    request.pageSize = this.pageSize;

    return this.situViewClient.listPagedArtifacts(request).then(response => {
      this.dataSource.data = response.items ?? [];
      this.totalItems = response.totalItems ?? 0;
      this.loading = false;
    }, error => {
      this.loading = false;
    });
  }

  viewDetail(id: string) {
    this.router.navigate(['/admin/recipe-event-summary', id]);
  }

  public getButtonText(artifact: IArtifactVersionItem): string {
    return artifact.active ? "Deactivate" : "Activate";
  }

  public toggleDisabled(artifact: IArtifactVersionItem): boolean {
    if (artifact.metaData?.some(x => x.key == "Error")) {
      return true;
    }
    return false;
  }

  public toggleArtifactActive(artifact: IArtifactVersionItem): void {
    this.loading = true;
    var request = new SetArtifactActiveRequest();
    request.callerReferenceKey = artifact.callerReferenceKey;
    request.version = artifact.version;
    request.active = !artifact.active;

    this.situViewClient.setArtifactActive(request).then(response => {
      this.loading = false;
      artifact.active = request.active;
    }, error => {
      this.loading = false;
    });
  }
}
